'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = withData;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreNamedRoutes2 = _interopRequireDefault(_bdcoreNamedRoutes);

var _actions = require('../Agents/actions');

var _actions2 = require('../Homes/actions');

var _actions3 = require('../Plans/actions');

var _actions4 = require('../Communities/actions');

var _actions5 = require('../Settings/actions');

var _actions6 = require('../Builder/actions');

var _actions7 = require('../Blogposts/actions');

var _actions8 = require('../Lots/actions');

var _actions9 = require('../Favorites/actions');

var _actions10 = require('../HoaPortal/actions');

var _actions11 = require('../Events/actions');

var _actions12 = require('../User/actions');

var _selectors = require('../Agents/selectors');

var _selectors2 = require('../Builder/selectors');

var _selectors3 = require('../Homes/selectors');

var _selectors4 = require('../Lots/selectors');

var _selectors5 = require('../Plans/selectors');

var _selectors6 = require('../Events/selectors');

var _selectors7 = require('../Communities/selectors');

var _selectors8 = require('../Settings/selectors');

var _selectors9 = require('../Blogposts/selectors');

var _actions13 = require('../ServerSide/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var find = {
  activeMapPin: function activeMapPin(requests, state) {
    return _lodash2.default.get(state, 'map.activePinId');
  },
  agent: function agent(requests, state, ownProps, props) {
    var agent = void 0;
    var agents = _lodash2.default.get(state, 'cloudData.agents.' + ownProps.builderId + '.data', []);

    if (props.community) {
      var communityAgentIds = _lodash2.default.get(props.community, 'agents', []);

      var _agents$filter$sort = agents.filter(function (a) {
        return communityAgentIds.includes(a._id);
      }).sort(function (a, b) {
        return communityAgentIds.indexOf(a._id) - communityAgentIds.indexOf(b._id);
      });

      var _agents$filter$sort2 = (0, _slicedToArray3.default)(_agents$filter$sort, 1);

      agent = _agents$filter$sort2[0];
    }

    if (!agent) {
      var _agents$filter = agents.filter(function (a) {
        return a.primary_osc;
      });

      var _agents$filter2 = (0, _slicedToArray3.default)(_agents$filter, 1);

      agent = _agents$filter2[0];
    }

    return agent;
  },
  agents: function agents(requests, state, ownProps, props) {
    var agents = _lodash2.default.get(state, 'cloudData.agents.' + ownProps.builderId + '.data', []);
    if (requests.agents === 'all') {
      return agents;
    }

    if (props.community) {
      var communityAgentIds = _lodash2.default.get(props.community, 'agents', []);
      var communityAgents = agents.filter(function (agent) {
        return communityAgentIds.includes(agent._id);
      }).sort(function (a, b) {
        return communityAgentIds.indexOf(a._id) - communityAgentIds.indexOf(b._id);
      });

      return communityAgents.length ? communityAgents : agents.filter(function (a) {
        return a.primary_osc;
      });
    }

    return (0, _selectors.getAgents)(state, ownProps);
  },
  area: function area(requests, state, ownProps, props) {
    if (props.home || props.lot) {
      var community = props.community || this.community(requests, state, ownProps, props);
      return (0, _selectors2.getArea)(state, { name: _lodash2.default.get(community, 'area') });
    } else if (props.community) {
      return (0, _selectors2.getArea)(state, { name: _lodash2.default.get(props.community, 'area') });
    }

    // Based on URL if possible
    return (0, _selectors2.getArea)(state, ownProps);
  },
  areas: function areas(requests, state, ownProps) {
    var filters = (0, _extends3.default)({}, ownProps);

    if (requests.areas === 'metros') {
      filters.metros = true;
    }

    var areas = (0, _selectors2.getAreas)(state, filters);

    if (requests.homes) {
      areas = areas.map(function (area) {
        var overrideFilters = {};
        if (area.isMetro) {
          overrideFilters.AreaMetro = [{ value: area, label: area.name }];
        } else if (area.parentMetro) {
          overrideFilters.AreaSubMetro = [{ value: area, label: area.name }];
        } else {
          overrideFilters.Area = [{ value: area, label: area.name }];
        }

        return (0, _extends3.default)({}, area, {
          homes: (0, _selectors3.getHomes)(state, (0, _extends3.default)({}, ownProps, { overrideFilters: overrideFilters }), ownProps.builderId)
        });
      });
    }

    if (requests.communities) {
      areas = areas.map(function (area) {
        var overrideFilters = {};
        if (area.isMetro) {
          overrideFilters.AreaMetro = [{ value: area, label: area.name }];
        } else if (area.parentMetro) {
          overrideFilters.AreaSubMetro = [{ value: area, label: area.name }];
        } else {
          overrideFilters.Area = [{ value: area, label: area.name }];
        }

        return (0, _extends3.default)({}, area, {
          communities: (0, _selectors7.getCommunities)(state, (0, _extends3.default)({}, ownProps, { overrideFilters: overrideFilters }), ownProps.builderId)
        });
      });
    }

    if (requests.plans) {
      areas = areas.map(function (area) {
        var overrideFilters = {};
        if (area.isMetro) {
          overrideFilters.AreaMetro = [{ value: area, label: area.name }];
        } else if (area.parentMetro) {
          overrideFilters.AreaSubMetro = [{ value: area, label: area.name }];
        } else {
          overrideFilters.Area = [{ value: area, label: area.name }];
        }

        return (0, _extends3.default)({}, area, {
          plans: (0, _selectors5.getPlans)(state, (0, _extends3.default)({}, ownProps, { overrideFilters: overrideFilters }), ownProps.builderId)
        });
      });
    }

    return areas;
  },
  blogpost: function blogpost(requests, state, ownProps) {
    return (0, _selectors9.getBlogpost)(state, ownProps);
  },
  blogposts: function blogposts(requests, state, ownProps) {
    if (requests.blogposts === 'all') {
      return _lodash2.default.get(state, 'cloudData.blogposts.' + ownProps.builderId + '.data', []);
    }
    return (0, _selectors9.getBlogposts)(state, ownProps);
  },
  builder: function builder(requests, state, ownProps) {
    return (0, _selectors2.getBuilder)(state, ownProps);
  },
  community: function community(requests, state, ownProps, props) {
    if (typeof requests.community === 'string') {
      var community = (0, _selectors7.getCommunity)(state, { _id: requests.community, builderId: ownProps.builderId });
      if (community) {
        return community;
      }
    }

    if (props.lot) {
      return (0, _selectors7.getCommunity)(state, { _id: _lodash2.default.get(props.lot, 'containedIn'), builderId: ownProps.builderId });
    }

    if (props.home) {
      return (0, _selectors7.getCommunity)(state, { _id: _lodash2.default.get(props.home, 'containedIn'), builderId: ownProps.builderId });
    }

    // Based on URL if possible
    return (0, _selectors7.getCommunity)(state, ownProps);
  },
  communities: function communities(requests, state, ownProps, props) {
    if (requests.communities === 'all') {
      return _lodash2.default.get(state, 'cloudData.communities.' + ownProps.builderId + '.data', []);
    }

    if (props.plan) {
      var planCommunities = _lodash2.default.get(props.plan, 'communities', []).reduce(function (result, commMod) {
        result.push(commMod.community);

        return result;
      }, []);

      return (0, _selectors7.getCommunities)(state, (0, _extends3.default)({}, ownProps, { overrideFilters: {} }), ownProps.builderId).filter(function (community) {
        return planCommunities.includes(community._id);
      });
    }

    // Based on URL if possible
    return (0, _selectors7.getCommunities)(state, ownProps, ownProps.builderId);
  },
  compare: function compare(requests, state, ownProps) {
    var itemIds = _lodash2.default.get(state, 'compare.items', []);
    var type = _lodash2.default.get(state, 'compare.type');
    var route = _lodash2.default.get(state, 'compare.route');

    return {
      items: _lodash2.default.get(state, 'cloudData.' + type + '.' + ownProps.builderId + '.data', []).filter(function (item) {
        return itemIds.includes(item._id);
      }),
      route: route,
      type: type
    };
  },
  hoaPortal: function hoaPortal(requests, state) {
    return _lodash2.default.get(state, 'hoaPortal.portal');
  },
  hoaPortals: function hoaPortals(requests, state) {
    return _lodash2.default.get(state, 'hoaPortal.portals', []);
  },
  home: function home(requests, state, ownProps) {
    return (0, _selectors3.getHome)(state, ownProps, ownProps.builderId);
  },
  homes: function homes(requests, state, ownProps, props) {
    if (requests.homes === 'all') {
      return _lodash2.default.get(state, 'cloudData.homes.' + ownProps.builderId + '.data', []);
    }

    if (props.home) {
      var community = props.community || (0, _selectors7.getCommunity)(state, { _id: _lodash2.default.get(props.home, 'containedIn') });
      if (community) {
        return _lodash2.default.get(state, 'cloudData.homes.' + ownProps.builderId + '.data', []).filter(function (home) {
          return home.containedIn === community._id;
        });
      }
    }

    if (props.plan) {
      return (0, _selectors3.getHomes)(state, (0, _extends3.default)({}, ownProps, { overrideFilters: {} }), ownProps.builderId).filter(function (home) {
        return home.plan === props.plan._id;
      });
    }

    var homes = (0, _selectors3.getHomes)(state, ownProps, ownProps.builderId);

    if (requests.community && props.community) {
      return homes.filter(function (h) {
        return h.containedIn === props.community._id;
      });
    }

    // Based on URL if possible
    return homes;
  },
  lot: function lot(requests, state, ownProps) {
    return (0, _selectors4.getLot)(state, ownProps, ownProps.builderId);
  },
  lots: function lots(requests, state, ownProps, props) {
    if (requests.lots === 'all') {
      return _lodash2.default.get(state, 'cloudData.lots.' + ownProps.builderId + '.data', []);
    }

    if (props.lot) {
      var community = props.community || (0, _selectors7.getCommunity)(state, { _id: _lodash2.default.get(props.lot, 'containedIn') });
      if (community) {
        return _lodash2.default.get(state, 'cloudData.lots.' + ownProps.builderId + '.data', []).filter(function (lot) {
          return lot.containedIn === community._id;
        });
      }
    }

    if (props.community) {
      return _lodash2.default.get(state, 'cloudData.lots.' + ownProps.builderId + '.data', []).filter(function (lot) {
        return lot.containedIn === props.community._id;
      });
    }

    return (0, _selectors4.getLots)(state, ownProps, ownProps.builderId);
  },
  favorites: function favorites(requests, state) {
    return _lodash2.default.get(state, 'favorites.items', []);
  },
  user: function user(requests, state) {
    return _lodash2.default.get(state, 'user.user');
  },
  userError: function userError(requests, state) {
    return _lodash2.default.get(state, 'user.loginError');
  },
  filters: function filters(requests, state) {
    return state.filters;
  },
  metro: function metro(requests, state, ownProps, props) {
    if (props.home || props.lot) {
      var community = props.community || this.community(requests, state, ownProps, props);
      var communityArea = (0, _selectors2.getArea)(state, { name: _lodash2.default.get(community, 'area') });
      if (communityArea && !communityArea.isMetro) {
        return (0, _selectors2.getArea)(state, { name: _lodash2.default.get(communityArea, 'parentMetro') });
      }
      return communityArea;
    } else if (props.community) {
      var _communityArea = (0, _selectors2.getArea)(state, { name: _lodash2.default.get(props.community, 'area') });
      if (_communityArea && !_communityArea.isMetro) {
        return (0, _selectors2.getArea)(state, { name: _lodash2.default.get(_communityArea, 'parentMetro') });
      }
      return _communityArea;
    }

    return (0, _selectors2.getMetro)(state, ownProps);
  },
  plan: function plan(requests, state, ownProps, props) {
    var plan = void 0;

    if (props.home) {
      plan = (0, _selectors5.getPlan)(state, { _id: _lodash2.default.get(props.home, 'plan'), builderId: ownProps.builderId });
    } else {
      plan = (0, _selectors5.getPlan)(state, ownProps);
    }

    if (props.community && _lodash2.default.get(plan, 'communities', []).find(function (pc) {
      return pc.community === props.community._id;
    })) {
      var _ref = plan.communities.find(function (pc) {
        return pc.community === props.community._id;
      }) || {},
          _ref$communityModelPr = _ref.communityModelProperties,
          communityModelProperties = _ref$communityModelPr === undefined ? {} : _ref$communityModelPr;

      plan = _lodash2.default.cloneDeep(plan);
      (0, _keys2.default)(communityModelProperties).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(communityModelProperties, key) && communityModelProperties[key]) {
          plan[key] = communityModelProperties[key];
        }
      });

      ['photos', 'floorplanPhotos', 'elevationPhotos'].forEach(function (type) {
        plan[type] = _lodash2.default.get(plan, type, []).filter(function (photo) {
          return !_lodash2.default.get(photo, 'hiddenCommunities') || !_lodash2.default.get(photo, 'hiddenCommunities.' + props.community._id, false);
        });
      });
    }

    // Based on URL if possible
    return plan;
  },
  plans: function plans(requests, state, ownProps, props) {
    if (requests.plans === 'all') {
      return _lodash2.default.get(state, 'cloudData.plans.' + ownProps.builderId + '.data', []);
    }

    var plans = (0, _selectors5.getPlans)(state, ownProps, ownProps.builderId);

    if (requests.community && props.community) {
      return plans.filter(function (p) {
        return _lodash2.default.get(p, 'communities', []).find(function (cm) {
          return cm.community === props.community._id;
        });
      }).map(function (rawPlan) {
        var comPlanData = _lodash2.default.get(rawPlan, 'communities', []).find(function (pc) {
          return pc.community === props.community._id;
        });
        if (comPlanData) {
          var _comPlanData$communit = comPlanData.communityModelProperties,
              communityModelProperties = _comPlanData$communit === undefined ? {} : _comPlanData$communit;

          var plan = _lodash2.default.cloneDeep(rawPlan);
          (0, _keys2.default)(communityModelProperties).forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(communityModelProperties, key) && communityModelProperties[key]) {
              plan[key] = communityModelProperties[key];
            }
          });

          ['photos', 'floorplanPhotos', 'elevationPhotos'].forEach(function (type) {
            plan[type] = _lodash2.default.get(plan, type, []).filter(function (photo) {
              return !_lodash2.default.get(photo, 'hiddenCommunities') || !_lodash2.default.get(photo, 'hiddenCommunities.' + props.community._id, false);
            });
          });

          return plan;
        }

        return rawPlan;
      });
    }

    // Based on URL if possible
    return plans;
  },
  event: function event(requests, state, ownProps, props) {
    return (0, _selectors6.getEvent)(state, ownProps);
  },
  events: function events(requests, state, ownProps, props) {
    return (0, _selectors6.getEvents)(state, ownProps);
  },
  page: function page(requests, state, ownProps) {
    if (typeof requests.page === 'string') {
      return (0, _selectors8.getPage)(state, (0, _extends3.default)({}, ownProps, { key: requests.page }));
    }

    // Try to match client page by slug from URL
    return (0, _selectors8.getPage)(state, ownProps);
  },
  submetro: function submetro(requests, state, ownProps, props) {
    if (props.home || props.lot) {
      var community = props.community || this.community(requests, state, ownProps, props);
      var communityArea = (0, _selectors2.getArea)(state, { name: _lodash2.default.get(community, 'area') });
      return communityArea;
    } else if (props.community) {
      var _communityArea2 = (0, _selectors2.getArea)(state, { name: _lodash2.default.get(props.community, 'area') });
      return _communityArea2;
    }

    return (0, _selectors2.getSubMetro)(state, ownProps);
  },
  settings: function settings(requests, state, ownProps) {
    return (0, _selectors8.getSettings)(state, ownProps);
  },
  recentHomes: function recentHomes(requests, state, ownProps) {
    var recentIds = _lodash2.default.get(state, 'cloudData.homes.recent', []);
    var homes = _lodash2.default.get(state, 'cloudData.homes.' + ownProps.builderId + '.data', []).filter(function (home) {
      return recentIds.includes(home._id);
    });
    return recentIds.reduce(function (result, id) {
      var home = homes.find(function (h) {
        return h._id === id;
      });
      if (home) {
        return [].concat((0, _toConsumableArray3.default)(result), [home]);
      }
      return result;
    }, []);
  },
  recentLots: function recentLots(requests, state, ownProps) {
    var recentIds = _lodash2.default.get(state, 'cloudData.lots.recent', []);
    var lots = _lodash2.default.get(state, 'cloudData.lots.' + ownProps.builderId + '.data', []).filter(function (lot) {
      return recentIds.includes(lot._id);
    });
    return recentIds.reduce(function (result, id) {
      var lot = lots.find(function (l) {
        return l._id === id;
      });
      if (lot) {
        return [].concat((0, _toConsumableArray3.default)(result), [lot]);
      }
      return result;
    }, []);
  },
  router: function router(requests, state) {
    return state.router;
  },
  utmCodes: function utmCodes(requests, state) {
    return _lodash2.default.get(state, 'utmCodes');
  },
  widget: function widget(requests, state, ownProps) {
    if (typeof requests.widget === 'string') {
      return (0, _selectors8.getWidget)(state, (0, _extends3.default)({}, ownProps, { key: requests.widget }));
    }

    // Try to match client page by slug from URL
    return (0, _selectors8.getWidget)(state, ownProps);
  },
  widgets: function widgets(requests, state, ownProps) {
    if (Array.isArray(requests.widgets)) {
      return requests.widgets.reduce(function (result, widget) {
        if (!result[widget]) {
          // eslint-disable-next-line no-param-reassign
          result[widget] = (0, _selectors8.getWidget)(state, (0, _extends3.default)({}, ownProps, { key: widget }));
        }

        return result;
      }, {});
    }

    return {};
  }
};

var isOnServer = process.env.REACT_APP_SERVER;
var NODE_ENV = process.env.NODE_ENV;
function withData() {
  var requests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var required = options.required,
      builderId = options.builderId,
      ifMissing404 = options.ifMissing404;


  return function (WrappedComponent) {
    var WithDataLoader = function (_React$Component) {
      (0, _inherits3.default)(WithDataLoader, _React$Component);

      function WithDataLoader() {
        (0, _classCallCheck3.default)(this, WithDataLoader);
        return (0, _possibleConstructorReturn3.default)(this, (WithDataLoader.__proto__ || (0, _getPrototypeOf2.default)(WithDataLoader)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithDataLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.requestData();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.requestData();
        }
      }, {
        key: 'requestData',
        value: function requestData() {
          var _this2 = this;

          var activeRequests = (0, _keys2.default)(requests);
          var requestPromises = [];

          requestPromises.push(this.props.dispatch((0, _actions6.fetchBuilderIfNeeded)(builderId)));
          if (['home', 'plan', 'homes', 'plans', 'community', 'communities', 'recentHomes'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions2.fetchHomesIfNeeded)(builderId)));
            requestPromises.push(this.props.dispatch((0, _actions3.fetchPlansIfNeeded)(builderId)));
            requestPromises.push(this.props.dispatch((0, _actions4.fetchCommunitiesIfNeeded)(builderId)));
          }
          if (['page', 'pages', 'widget', 'widgets', 'settings'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions5.fetchSettingsIfNeeded)(builderId)));
          }
          if (['blogpost', 'blogposts'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions7.fetchBlogpostsIfNeeded)(builderId)));
          }
          if (['lots', 'lot', 'recentLots'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions8.fetchLotsIfNeeded)(builderId)));
          }
          if (['agents', 'agent'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions.fetchAgentsIfNeeded)(builderId)));
          }
          if (['favorites'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions9.fetchFavoritesIfNeeded)(builderId)));
          }
          if (['hoaPortal', 'hoaPortals'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions10.fetchHoaPortalIfNeeded)(builderId)));
          }
          if (['event', 'events'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions11.fetchEventsIfNeeded)(builderId)));
          }
          if (['user'].find(function (request) {
            return activeRequests.includes(request);
          }) || isOnServer) {
            requestPromises.push(this.props.dispatch((0, _actions12.fetchUserIfNeeded)(builderId)));
          }

          _promise2.default.all(requestPromises).catch(function (fatalError) {
            console.error(fatalError);
            _this2.props.setPageStatus(500, 'Getting Builder Cloud Data ' + fatalError.message);
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          if (this.props.fetching) {
            return null;
          }

          var allDataLoaded = (0, _keys2.default)(requests).reduce(function (loaded, request) {
            if ((!required || required[request]) && !_this3.props[request]) {
              return false;
            }

            return loaded;
          }, true);

          if (!allDataLoaded && ifMissing404 && !this.props.fetching) {
            var NoRoute = _bdcoreUtilities.ComponentCollection.getComponent('NoRoute');
            this.props.setPageStatus(404);
            return _react2.default.createElement(NoRoute, null);
          } else if (!allDataLoaded) {
            return null;
          }

          return _react2.default.createElement(WrappedComponent, this.props);
        }
      }]);
      return WithDataLoader;
    }(_react2.default.Component);

    WithDataLoader.propTypes = {
      dispatch: _propTypes2.default.func.isRequired,
      setPageStatus: _propTypes2.default.func.isRequired,
      fetching: _propTypes2.default.bool.isRequired
    };

    WithDataLoader.displayName = 'WithDataLoader(' + getDisplayName(WrappedComponent) + ')';

    /*
      {
        area: boolean, // Loaded from route params or entity
        areas: boolean,
        page: 'page_key',
        widget: 'widget_key',
        home: boolean,  // Loaded from route params
        homes: boolean,
        community: boolean, // Loaded from route params
        communities: boolean,
        plan: boolean, // Loaded from route params
        plans: boolean,
        blogpost: boolean, // Loaded from route params
        blogposts: boolean,
        events: boolean,
      }
    */
    function mapStateToProps(state, ownProps) {
      var inputProps = (0, _extends3.default)({}, ownProps, {
        builderId: builderId || _bdcoreUtilities.ConfigStore.getConfig('builder_id')
      });

      if (!inputProps.match) {
        inputProps.match = _bdcoreNamedRoutes2.default.getRouteByPath(_lodash2.default.get(state, 'router.location.pathname'));
      }

      var activeRequests = (0, _keys2.default)(requests);
      var waitOnFetchFor = [];

      if (['builder', 'area', 'areas', 'metro', 'submetro'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.builder']);
      }
      if (['community', 'communities'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.communities']);
      }
      if (['home', 'homes', 'recentHomes'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.homes']);
      }
      if (['plan', 'plans'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.plans']);
      }
      if (['page', 'pages', 'widget', 'widgets', 'settings'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.settings']);
      }
      if (['blogpost', 'blogposts'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.blogposts']);
      }
      if (['lots', 'lot', 'recentLots'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.lots']);
      }
      if (['agents', 'agent'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.agents']);
      }
      if (['user'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['user']);
      }
      if (['event', 'events'].find(function (request) {
        return activeRequests.includes(request);
      }) || isOnServer) {
        waitOnFetchFor.push.apply(waitOnFetchFor, ['cloudData.events']);
      }

      var props = (0, _extends3.default)({}, options.injectProps || {}, {
        fetching: waitOnFetchFor.reduce(function (result, key) {
          var innerKeys = (0, _typeof3.default)(_lodash2.default.get(state, key)) === 'object' ? (0, _keys2.default)(_lodash2.default.get(state, key)) : [];

          if (innerKeys.length === 0) {
            return true;
          }

          var innerResult = innerKeys.reduce(function (ir, innerKey) {
            return innerKey === 'isFetching' && _lodash2.default.get(state, key)[innerKey] || innerKey === inputProps.builderId && _lodash2.default.get(state, key)[innerKey].isFetching || ir;
          }, false);

          return innerResult || result;
        }, false),
        match: inputProps.match
      });

      (0, _keys2.default)(requests).forEach(function (key) {
        if (_lodash2.default.has(inputProps, key) && _lodash2.default.get(inputProps, key)) {
          props[key] = _lodash2.default.get(inputProps, key);
        } else if (_lodash2.default.has(find, key)) {
          props[key] = find[key](requests, state, inputProps, props);
        } else if (NODE_ENV === 'development') {
          var keyError = new Error('Key Error: ' + getDisplayName(WrappedComponent) + ' is requesting the invalid key "' + key + '" using withData please check your spelling.');
          console.error(keyError);
          console.warn('BDCORE Warning: unsupported keys in withData has been deprecated. Future versions of bdcore will treat this as a fatal error. Please remove any keys currently reporting as an error');
        }
      });

      return props;
    }

    return (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
      return {
        dispatch: dispatch,
        setPageStatus: function setPageStatus() {
          var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
          var error = arguments[1];
          return dispatch((0, _actions13.setPageStatus)(status, error));
        }
      };
    })(WithDataLoader);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/withData/withData.js
// module id = 949
// module chunks = 0